import type { ReactNode } from 'react';
import { NeutralActionButton } from '@/shared/components/ui/NeutralActionButton';

interface NeutralStatePanelProps {
  title: ReactNode;
  description?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  role?: 'status' | 'alert';
  className?: string;
}

export function NeutralStatePanel({
  title,
  description,
  actionLabel,
  onAction,
  role = 'status',
  className = '',
}: NeutralStatePanelProps) {
  return (
    <section
      className={[
        'rounded-[16px] border border-[rgba(26,26,26,0.08)] bg-[rgba(255,255,255,0.68)] p-[14px]',
        className,
      ].join(' ')}
      role={role}
      aria-live={role === 'alert' ? 'assertive' : 'polite'}
    >
      <p className="text-[16px] font-semibold leading-[1.25] text-[var(--foreground)]">{title}</p>
      {description ? (
        <p className="mt-2 text-[14px] leading-[1.45] text-[rgba(26,26,26,0.6)]">{description}</p>
      ) : null}
      {actionLabel && onAction ? (
        <div className="mt-4">
          <NeutralActionButton onClick={onAction}>{actionLabel}</NeutralActionButton>
        </div>
      ) : null}
    </section>
  );
}
